module.exports = __webpack_public_path__ + "img/16d004-12.5f8c6599.jpg";